import { router } from '~/app/router'

export
default
router.constructor
